import { ICostInCurrencyPerDay, IPrice } from "~/types/IPrice";
import { useMemo } from "react";
import { dividedByThree } from "~helpers/constant";
import {useAppSelector} from "~/hooks/redux";

interface IPriceData {
  [country: string]: {
      currency: string,
      price: number | string,
  };
}

export const usePriceData = (isLegalPerson: boolean, service: IPrice) => {
  const { country } = useAppSelector(state => state.countryReducer)

  const cost: ICostInCurrencyPerDay = useMemo(() => {
    return service?.cost_in_currency_per_day.find((item) =>
      item.currency === ((isLegalPerson ? 'RUB' : country?.currency)))
  }, [service, country, isLegalPerson])

  const price: number = cost?.cost / 100 * service?.step_period_count

  const priceData: IPriceData = {
    RU: { price: Math.round(price), currency: '₽' },
    UZ: { price: dividedByThree(price, ' '), currency: 'UZS' },
    KZ: { price: Math.round(price), currency: '₸' },
  }

  return priceData[country?.value]?.price + ' ' + priceData[country?.value]?.currency
}
